import { Mobile } from "../components/device"
import AppLogo from "./app_logo"
import type { Styles } from "@/types/util"

const styles = {
  logo: {
    height: 35,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
} satisfies Styles

const AppHeaderCenter = () => {
  return (
    <Mobile>
      <AppLogo style={styles.logo} />
    </Mobile>
  )
}

export default AppHeaderCenter
